import { IWebsiteBuilderElementBase, IWebsiteBuilderElementDataBase, TWebsiteBuilderElement } from "./websiteBuilderElement";
import { IWebsiteBuilderNodeDesignStyles } from "../websiteBuilderNode";
import { websiteBuilderGenerateDefaultHideableNodeVisibility } from "../websiteBuilderHideableNode";

export interface IWebsiteBuilderNavigationMenuData extends IWebsiteBuilderElementDataBase {
  type: "navigation-menu";
  settings: null;
}

export interface IWebsiteBuilderNavigationMenu extends IWebsiteBuilderElementBase {
  element: IWebsiteBuilderNavigationMenuData;
}

export function isWebsiteBuilderNavigationMenu(node: TWebsiteBuilderElement): node is IWebsiteBuilderNavigationMenu {
  return node?.element?.type === "navigation-menu";
}

export function websiteBuilderGenerateDefaultNavigationMenu(): IWebsiteBuilderNavigationMenu {
  return {
    id: crypto.randomUUID(),
    type: "element",
    element: {
      type: "navigation-menu",
      layout: {
        desktop: {
          position: { x: 0, y: 0 },
          dimensions: { width: 300, height: 50 },
        },
        tablet: {
          position: { x: 0, y: 0 },
          dimensions: { width: 25, height: 30 },
        },
        mobile: {
          position: { x: 0, y: 0 },
          dimensions: { width: 25, height: 30 },
        },
      },
      visibility: websiteBuilderGenerateDefaultHideableNodeVisibility(),
      zIndex: 0,
      settings: null,
    },
  };
}

interface IWebsiteBuilderNavigationMenuDesignStyles extends IWebsiteBuilderNodeDesignStyles {
  linkClassName: string;
  linkActiveClassName: string;
  dropbuttonClassName: string;
}

export function websiteBuilderGenerateNavigationMenuDesignStyles(): IWebsiteBuilderNavigationMenuDesignStyles {  
  return {
    className: "website-builder-navigation-menu",
    linkClassName: "website-builder-navigation-menu-link",
    linkActiveClassName: "website-builder-navigation-menu-link-active",
    dropbuttonClassName: "website-builder-navigation-menu-dropdown-dropbutton",
    styleProperties: {},
    styleDeclaration: "",
  };
}